import { useState, useCallback } from 'react';
import { useToast } from '@chakra-ui/react';
import excelModalApi from '../../../../services/excelModalApi';

export const useScenarioData = (editingFile, currentFY) => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [scenario, setScenario] = useState('');
  const [tahsils, setTahsils] = useState([]);
  const [availableMonths, setAvailableMonths] = useState([]);
  const [fileType, setFileType] = useState(null);
  const [error, setError] = useState(null);

  const getFileTypeId = useCallback(() => {
    if (!editingFile) return null;
    if (typeof editingFile === 'string') return editingFile;
    return editingFile.fileType || editingFile._id || null;
  }, [editingFile]);

  const loadScenario = useCallback(async (month = null) => {
    const fileTypeId = getFileTypeId();
    
    if (!fileTypeId) {
      setError('No file type selected');
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await excelModalApi.getScenarioData(
        fileTypeId,
        currentFY,
        month
      );

      if (result.success) {
        setScenario(result.scenario);
        setTahsils((result.sdoUsers && result.sdoUsers.length > 0 ? result.sdoUsers : null) || result.tahsils || result.sdos || result.sdoList || []);
        setAvailableMonths(result.availableMonths || []);
        setFileType(result.fileType);
        return result;
      } else {
        setError(result.error);
        toast({
          title: 'Error loading data',
          description: result.error,
          status: 'error',
          duration: 3000
        });
        return null;
      }
    } catch (err) {
      const errorMsg = err.message || 'Failed to load scenario';
      setError(errorMsg);
      toast({
        title: 'Error',
        description: errorMsg,
        status: 'error',
        duration: 3000
      });
      return null;
    } finally {
      setLoading(false);
    }
  }, [getFileTypeId, currentFY, toast]);

  return {
    loading,
    scenario,
    tahsils,
    availableMonths,
    fileType,
    error,
    loadScenario,
    setScenario,
    setTahsils,
    setAvailableMonths
  };
};